export default "__VITE_ASSET__C0VmO9f7__"